module.exports = __webpack_public_path__ + "static/media/archive-open445434a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/archive-open.svg
// module id = 672
// module chunks = 0